<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <!-- Header -->
          <div class="d-flex flex-row flex-wrap justify-content-between mb-4">
            <div>
              <h1 class="card-title mb-1">Payments</h1>
              <span class="sub-text">View and manage payment records</span>
            </div>
            <button
              class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2"
              (click)="exportDetailed()"
              title="Downloads every payment the current filters match, so the sheet adds up to the Total (all filters) figure."
              [disabled]="isExporting">
              @if (isExporting) {
                <span class="spinner-border spinner-border-sm"></span>
              } @else {
                <i class="bi bi-download"></i>
              }
              Export
            </button>
          </div>

          <!-- Filters -->
          <div class="bg-light p-3 border mb-4">
            <div class="row g-3 align-items-end" *ngIf="isFiltersVisible">
              <div class="col-md-4">
                <ng-select
                  placeholder="Select Company"
                  [items]="companies"
                  [(ngModel)]="selectedCompanyId"
                  bindValue="id"
                  bindLabel="name"
                  [clearable]="true"
                  [searchable]="false"
                  (ngModelChange)="onFilterChange()" />
              </div>
              <div class="col-md-4">
                <ng-select
                  placeholder="Select Employee"
                  [items]="employees"
                  [(ngModel)]="selectedEmployeeId"
                  bindValue="user_id"
                  bindLabel="full_name"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>
              <div class="col-md-4">
                <ng-select
                  placeholder="Select Dealer"
                  [items]="dealers"
                  [(ngModel)]="selectedDealerId"
                  bindValue="id"
                  bindLabel="shop_name"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>
              <div class="col-md-4">
                <ng-select
                  placeholder="Payment Type"
                  [items]="paymentTypeOptions"
                  [(ngModel)]="selectedPaymentType"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="true"
                  [searchable]="false"
                  (ngModelChange)="onFilterChange()" />
              </div>
              <div class="col-md-4">
                <input
                  type="date"
                  class="form-control"
                  placeholder="Start Date"
                  [(ngModel)]="startDate"
                  (change)="onFilterChange()" />
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <div>
                  <input
                    type="date"
                    class="form-control"
                    placeholder="End Date"
                    [(ngModel)]="endDate"
                    (change)="onFilterChange()" />
                </div>
                <div>
                  <button class="btn btn-soft-secondary" (click)="onClearFilters()" title="Reset Filters">
                    <i class="bi bi-arrow-counterclockwise"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Table -->
          @if (isLoading && !payments.length) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <div class="table-responsive custom-table-container">
              <table class="table align-middle table-hover">
                <thead class="text-muted">
                  <tr>
                    <th>Date</th>
                    <th>Company</th>
                    <th>Employee</th>
                    <th>Dealer</th>
                    <th>Reference No</th>
                    <th>Payment Type</th>
                    <th>Amount</th>
                    <th>Bank Name</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  @if ((payments || []).length === 0) {
                    <tr>
                      <td colspan="9" class="text-center py-4 text-muted fs-6">No payments found.</td>
                    </tr>
                  }
                  <tr *ngFor="let payment of payments" (click)="viewDetails(payment)" style="cursor: pointer">
                    <td>{{ payment.date | date: 'mediumDate' }}</td>
                    <td>{{ payment.company?.name || '-' }}</td>
                    <td>{{ payment.employee.full_name || '-' }}</td>
                    <td>
                      <div class="d-flex flex-column" *ngIf="payment.dealer">
                        <span class="fw-bold">{{ payment.dealer.shop_name }}</span>
                        <span class="text-muted small">
                          {{ payment.dealer.first_name }} {{ payment.dealer.last_name }}
                        </span>
                      </div>
                      <span *ngIf="!payment.dealer">-</span>
                    </td>
                    <td>{{ payment.reference_number || '-' }}</td>
                    <td class="text-capitalize">{{ payment.payment_type.toUpperCase() }}</td>
                    <td class="fw-bold">{{ payment.received_amount | currency: 'INR' }}</td>
                    <td>{{ payment.bank_name || '-' }}</td>
                    <td>{{ payment.remarks || '-' }}</td>
                  </tr>
                </tbody>

                <!-- Both figures come off the response, never summed from the rows on screen. -->
                @if (pageReceivedAmount !== null && totalReceivedAmount !== null) {
                  <tfoot class="payments-totals" [class.payments-totals--stale]="isLoading">
                    <tr class="table-light border-top">
                      <td colspan="6" class="py-2 pe-3 text-end text-muted small fw-semibold">This page</td>
                      <td class="py-2 fw-bold small">{{ formatDecimalAmount(pageReceivedAmount) }}</td>
                      <td colspan="2"></td>
                    </tr>
                    <tr class="table-light">
                      <td colspan="6" class="py-2 pe-3 text-end text-muted small fw-semibold">Total (all filters)</td>
                      <td class="py-2 fw-bold">{{ formatDecimalAmount(totalReceivedAmount) }}</td>
                      <td colspan="2"></td>
                    </tr>
                  </tfoot>
                }
              </table>

              <app-pagination
                [currentPage]="currentPage"
                [totalCount]="totalCount"
                [pageSize]="pageSize"
                [hasNextPage]="hasNextPage"
                [hasPreviousPage]="hasPreviousPage"
                (pageChange)="onPageChange($event)"></app-pagination>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
